'use client'

import { useEffect } from 'react'

// يحفظ آخر سيارة عرض الزبون قطعها (ورقم هيكلها إن بحث به) في كعكة `order_vehicle`.
// addToCart يقرؤها فيحفظها على سطر السلة، فتصل مع الطلب إلى التاجر ليراجع
// توافق القطعة ويصحّح للزبون إن لزم. (الاسم مكرَّر في lib/data/cart.ts عمداً:
// ثابتٌ من ملف 'use client' لا يصل إلى الخادم نصّاً.)
// `name`: الاسم المختصر للسيارة من «سياراتي» («سيارة العمل»).
export function RememberVehicle({ id, label, vin, name }: { id?: string; label: string; vin?: string; name?: string }) {
  useEffect(() => {
    const value = encodeURIComponent(JSON.stringify({ id, label, vin, name }))
    document.cookie = `order_vehicle=${value}; path=/; max-age=${60 * 60 * 24 * 7}; samesite=lax`
  }, [id, label, vin, name])
  return null
}
